export default __webpack_public_path__ + "static/media/admin_big@2x.4f91bec1.png";